(function () {    
    angular.module('bizPartEngage').directive('bizOneGoalActivity', bizOneGoalActivityDirective);
       
    bizOneGoalActivityDirective.$inject = ["bizCore"];   

    function bizOneGoalActivityDirective(bizCoreProvider) {
        var directive = {
            restrict: 'E',
            scope: {
                activity: '='
            },
            templateUrl: bizCoreProvider.getView('bizOneGoalActivityDirective', 'FrontEnd/Modules/EngagementGoals/Views/Directives/oneActivity.html'),
            bindToController: true,
            controller: bizOneGoalActivityController,
            controllerAs: 'vm'
        };

        bizOneGoalActivityController.$inject = ["modules.goals.service", "$scope", "$q", "$mdToast", "$timeout", "bizValidationService", "$rootScope", "$mdDialog", "$state"];

        return directive;

        function bizOneGoalActivityController(engagementGoalsService, $scope, $q, $mdToast, $timeout, bizValidationService, $rootScope, $mdDialog, $state) {
            var vm = this;

            vm.Init = Init;
            vm.GetGoalTypes = GetGoalTypes;
            vm.GetGoals = GetGoals;
            vm.Save = Save;
            vm.SetActivityLoaded = SetActivityLoaded;

            vm.activityIsLoadedDefer = $q.defer();
            vm.activityIsLoaded = vm.activityIsLoadedDefer.promise;
            vm.Back = Back;
            vm.DeleteActivity = DeleteActivity;

            function Back() {
                window.history.back();
            }

            function GetGoals() {
                var pGetGoals = engagementGoalsService.GetGoals();
                $q.all([pGetGoals, vm.activityIsLoaded]).then(GetGoalsCallback);

                function GetGoalsCallback(result) {
                    var goals = BizPartCoreHelpers.getResponseValue(result[0], []);     
                    goals = goals.filter(g => g.ParentGoalId > 0);
                    var activityGoal;

                    for (var i = 0; i < goals.length; i++) {
                        if (goals[i].Id == vm.activity.GoalId) {                            
                            activityGoal = goals[i];
                        }                        
                    }

                    if (activityGoal) {
                        vm.SelectedGoal = activityGoal;
                    }
                    else if (goals.length) {
                        //vm.SelectedGoal = goals[0];
                    }
                    
                    vm.Goals = goals;
                }
            }

            function Save() {
                if (vm.MyForm && !bizValidationService.FormValid(vm.MyForm))
        		    return;

                vm.activity.DateLocal = moment(vm.activity.DateLocalDate);
                vm.activity.GoalId = vm.SelectedGoal.Id;
                vm.activity.GoalTypeId = vm.SelectedType ? vm.SelectedType.Id : 0;
                var saveData = {
                    Activity: vm.activity,
                    Comment: vm.NewComment
                };
                if (saveData.Activity.GoalValue && typeof saveData.Activity.GoalValue !== "number")
                    saveData.Activity.GoalValue = ~~saveData.Activity.GoalValue.replace(/\s/g, '');

                if (saveData.Activity.GoalValue && saveData.Activity.GoalValue <= 0) {
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent('Nyckelområdets tal måste vara större än 0')
                            .position('bottom right')
                    );
                    return;
                }

                engagementGoalsService.CreateUpdateActivity(saveData).then(SaveActivityCallback);

                function SaveActivityCallback(response) {
                    var newCreated = vm.activity.Id <= 0;
                    var activity = BizPartCoreHelpers.getResponseValue(response);                    
                    vm.NewComment = undefined;                                        
                    if (newCreated) {
                        vm.activity = {
                            Id: 0,
                            GoalId: activity.GoalId,
                            GoalValue: activity.GoalValue,
                            GoalTypeId: vm.SelectedType ? vm.SelectedType.Id : 0,
                            DateLocalDate: moment(activity.DateLocal).format('YYYY-MM-DD'),
                        };
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent('Nyckelområde sparat, lägg till ännu fler om du vill!')
                                .position('bottom right')
                        );       
                        
                        $rootScope.$broadcast('GOALACTIVITYCREATED', activity);
                    } else {
                        vm.activity = activity;
                        vm.activity.DateLocalDate = moment(vm.activity.DateLocal).format('YYYY-MM-DD');
                        vm.EditMode = false;
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent('Nyckelområde sparat')
                                .position('bottom right')
                        );       
                    }                    

                    //$timeout(function () {
                    //    vm.Back();
                    //}, 1000);
                }                
            }

            function GetGoalTypes() {
                engagementGoalsService.GetGoalTypes().then(GetGoalTypesCallback);

                function GetGoalTypesCallback(response) {
                    vm.GoalTypes = BizPartCoreHelpers.getResponseValue(response, []);          

                    $q.when(vm.activityIsLoaded).then(function () {
                        if (vm.activity.GoalTypeId) {
                            vm.SelectedType = vm.GoalTypes.GetItemByValue('Id', vm.activity.GoalTypeId);
                        }
                    });
                }
            }

            function DeleteActivity() {
                var confirm = $mdDialog.confirm()
                    .title('Radera')
                    .textContent('Är du säker på att du vill radera detta "nyckelområde"?')
                    .ok('Ja')
                    .cancel('Avbryt');

                $mdDialog.show(confirm).then(function () {
                    engagementGoalsService.DeleteActivity(vm.activity.Id).then(function (response) {
                        $state.go('base.modules.goals.engagementgoals');
                    });                    
                }, function () {
                    
                });
            }

            function Init() {
                vm.GetGoalTypes();

                if (vm.activity) {
                    var period = engagementGoalsService.GetSelectedPeriod();
                    if (vm.activity.Id === 0) {
                        vm.activity.Text = ''
                        vm.EditMode = true;
                        vm.activity.DateLocal = period.IsCurrentPeriod ? BizPartCoreHelpers.getDateNow() : period.EndDate;
                    }
                    vm.SetActivityLoaded();
                }

                vm.GetGoals();
            }

            function SetActivityLoaded() {
                vm.activity.DateLocalDate = moment(vm.activity.DateLocal).format('YYYY-MM-DD');
                vm.activityIsLoadedDefer.resolve('');
                vm.unbindActivityWatch();
            }

            $scope.$watch("vm.SelectedGoal", function () {
                if (vm.SelectedGoal && ~~vm.activity.Id <= 0) {                    
                    vm.activity.DateLocalDate = moment(vm.SelectedGoal.DateToLocal).format('YYYY-MM-DD');
                }
            });

            vm.unbindActivityWatch = $scope.$watch("vm.activity", function () {
                if (vm.activity !== undefined) {
                    vm.SetActivityLoaded();
                }
            });

            vm.$onInit = vm.Init;
        }
    }

}());